import script from "./LogoutView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogoutView.vue?vue&type=script&setup=true&lang=ts"

import "./LogoutView.vue?vue&type=style&index=0&id=75ffccce&lang=scss&scoped=true"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75ffccce"]])

export default __exports__